import citations from './generated-ai-citations.json' with {type: 'json'};
import {siteOrigin} from '../site-config.mjs';

export function citationLink(href) {
  if (!href) return href;
  try {
    const url = new URL(href, siteOrigin);
    if (url.origin !== siteOrigin) return href;
    const match = citations[url.pathname.replace(/\.(?:md|mdx)$/, '')];
    return match?.url || href;
  } catch {return href;}
}

function sourceProduct(href) {
  try {
    const url = new URL(href, siteOrigin);
    if (url.origin !== siteOrigin) return null;
    return url.pathname.match(/\/(?:products\/|catalog\/core-trading-)(spot|futures|wallet|copy|broker|partner)(?:\/|$)/)?.[1] || null;
  } catch {return null;}
}

const productSuffix = /\s*[（(](?:现货|合约|钱包|跟单|经纪商|合作伙伴|合伙人|Spot|Futures|Wallet|Copy(?: Trading)?|Broker|Partner)[）)]$/i;

export function citationMarkdown(text) {
  // Keep code examples intact and only disambiguate source-list titles.
  const chunks = text.split(/(```[^]*?```|~~~[^]*?~~~)/g);
  return chunks.map((chunk, index) => {
    if (index % 2) return chunk;
    const normalized = chunk.replace(/(\]\()(https?:\/\/[^\s)]+|\/[^\s)]+)(\))/g, (_, open, href, close) => `${open}${citationLink(href)}${close}`);
    return normalized.replace(/((?:^|\n)(?:#{1,6}\s+)?(?:\*\*)?(?:Sources|来源|参考来源):?(?:\*\*)?[^\S\n]*\n)([^]*?)(?=\n#{1,6}\s|$)/gi, (_, heading, sources) => {
      const links = [...sources.matchAll(/\[([^\]\n]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g)];
      const products = new Map();
      for (const [, title, href] of links) {
        const product = sourceProduct(href);
        if (product) {
          const key = title.replace(productSuffix, '');
          if (!products.has(key)) products.set(key, new Set());
          products.get(key).add(product);
        }
      }
      return heading + sources.replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g, (link, title, href) => {
        const product = sourceProduct(href);
        const key = title.replace(productSuffix, '');
        if (!product || productSuffix.test(title) || (products.get(key)?.size || 0) < 2) return link;
        const zh = /[\u3400-\u9fff]/.test(title);
        const names = {spot: ['现货', 'Spot'], futures: ['合约', 'Futures'], wallet: ['钱包', 'Wallet'], copy: ['跟单', 'Copy Trading'], broker: ['经纪商', 'Broker'], partner: ['合作伙伴', 'Partner']};
        return `[${title}${zh ? '' : ' '}(${names[product][zh ? 0 : 1]})](${href})`;
      });
    });
  }).join('');
}
